import React from "react";
import { X } from "lucide-react";
import Reveal from "../components/Reveal";
import { useLang } from "../contexts/LangContext";
import { api } from "../lib/api";
import { PageHeader } from "./Formats";

export default function Galleria() {
  const { t, lang } = useLang();
  const [items, setItems] = React.useState([]);
  const [active, setActive] = React.useState(null);

  React.useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="galleria-page">
      <PageHeader eyebrow={t.gallery.eyebrow} title={t.gallery.title} subtitle={t.gallery.subtitle} />

      <section className="bg-[#0a0a0a] pb-32">
        <div className="container-x">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {items.map((g, i) => (
              <Reveal key={g.id} delay={(i % 4) * 60}>
                <button
                  onClick={() => setActive(g)}
                  className="block w-full aspect-[4/5] zoom-img relative cursor-zoom-in border border-white/5 hover:border-[color:var(--gold)]/60 transition-colors"
                  data-testid={`gallery-item-${i}`}
                >
                  <img src={g.image_url} alt="" className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-black/0 hover:bg-black/30 transition-colors" />
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-white/70 hover:text-white"
            aria-label="Close"
            data-testid="gallery-close"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={active.image_url}
            alt=""
            className="max-w-[92vw] max-h-[88vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          {(active.caption_it || active.caption_en) && (
            <div className="absolute bottom-6 left-0 right-0 text-center text-white/70 text-sm font-display tracking-wide">
              {lang === "it" ? active.caption_it : active.caption_en}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
